'use client'
import { createContext, useContext, useState, useEffect, useCallback } from 'react'

const CartContext = createContext(null)
const KEY = 'sk-aqua-cart'

export function CartProvider({ children }) {
  const [items, setItems] = useState([])
  const [cartOpen, setCartOpen] = useState(false)

  // Hydrate from localStorage once on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY)
      if (stored) setItems(JSON.parse(stored))
    } catch {}
  }, [])

  const persist = (next) => {
    try { localStorage.setItem(KEY, JSON.stringify(next)) } catch {}
  }

  const add = useCallback((item, qty = 1) => {
    setItems(prev => {
      const next = prev.find(x => x.id === item.id)
        ? prev.map(x => x.id === item.id ? { ...x, qty: x.qty + qty } : x)
        : [...prev, { ...item, qty }]
      persist(next)
      return next
    })
  }, [])

  const remove = useCallback((id) => {
    setItems(prev => {
      const next = prev.filter(x => x.id !== id)
      persist(next)
      return next
    })
  }, [])

  const setQty = useCallback((id, qty) => {
    if (qty < 1) { remove(id); return }
    setItems(prev => {
      const next = prev.map(x => x.id === id ? { ...x, qty } : x)
      persist(next)
      return next
    })
  }, [remove])

  const clear = useCallback(() => {
    setItems([])
    try { localStorage.removeItem(KEY) } catch {}
  }, [])

  const count = items.reduce((s, x) => s + x.qty, 0)
  const openCart  = useCallback(() => setCartOpen(true),  [])
  const closeCart = useCallback(() => setCartOpen(false), [])

  return (
    <CartContext.Provider value={{ items, count, cartOpen, openCart, closeCart, add, remove, setQty, clear }}>
      {children}
    </CartContext.Provider>
  )
}

export const useCart = () => useContext(CartContext)
